module.exports = __webpack_public_path__ + "img/b5.611ade92.png";